import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ElectricityOperatorListInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-list', title: 'Electricity Operator List', subtitle: 'Fetch the list of electricity operators and their codes' }}
        fields={[]}
        endpoint={{
            method: 'GET',
            path: '/surepass/utility/electricity/operator-code-list',
            bodyMapper: (_v, sid) => ({ api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="electricity-operator-list"
        submitLabel="Fetch Operator List"
        successSummary="Operator list fetched"
        errorSummary="Operator list fetch failed"
        confirmHeader="Fetch electricity operator list"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Electricity Operators', icon: 'pi-list' }}
    />
);

export default ElectricityOperatorListInputComponent;
